import React from 'react'
import ProcessorModal from '.'

export default function ConfirmCloseModal({ open = false, onClose = () => {}, onSubmit = () => {} }) {
  return (
    <ProcessorModal open={open} onClose={onClose}>
      <div style={{ padding: '36px 60px 24px 60px', background: 'white', borderRadius: 6 }}>
        <div className="dome-d-flex dome-flex-column dome-gap24">
          <div className="dome-d-flex dome-flex-column dome-gap12">
            <span>
              <i style={{ fontSize: '50px' }} className="fa-thin fa-circle-exclamation dome-color-dark-grey"></i>
            </span>
            <span className="dome-h2 dome-color-dark-grey">are you sure?</span>
          </div>
          <div style={{ width: 380 }} className="dome-d-flex dome-flex-column dome-gap24">
            <span className="dome-p1-lt dome-color-darkest-grey">
              If you haven’t yet saved your sections, your progress will be lost.
            </span>
          </div>
          <div className="dome-d-flex dome-justify-between">
            <button
              type="button"
              onClick={onClose}
              className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
            >
              go back to save
            </button>
            <button type="button" onClick={onSubmit} className="dome-btn dome-btn-base dome-btn-green-stroke">
              exit
            </button>
          </div>
        </div>
      </div>
    </ProcessorModal>
  )
}
